<div class="tfa-header">
  <div class="tfa-icon-wrapper">
    <mat-icon class="tfa-icon">
      verified_user
    </mat-icon>
  </div>
  <h2 class="tfa-title">
    {{data.title}}
  </h2>
  <p class="tfa-message"
     [innerHTML]="data.message"></p>
</div>

<div *ngIf="data.mode === 'radio'"
     class="tfa-radio-options">
  <mat-radio-button *ngFor="let option of data.options"
                    [value]="option.value"
                    (click)="handleChoose(option.value)">
    {{ option.name }}
  </mat-radio-button>
</div>

<div *ngIf="data.mode === 'button'"
     class="tfa-button-options">
  <button *ngFor="let option of data.options"

          class="tfa-option-btn"
          color="warn"

          mat-flat-button
          (click)="handleChoose(option.value)">
    {{ option.name }}
  </button>
</div>

<div *ngIf="data.showLogout"
     class="tfa-signout">
  <button class="tfa-signout-btn"
          mat-button
          (click)="handleChoose('logout')">
    <mat-icon>
      logout
    </mat-icon>
    Sign out
  </button>
</div>
